import { useState, useEffect } from 'react';
import { clientService } from '../services/clientService';
import type { Client, ClientStatus } from '@shared/types';

interface ClientFilters {
  status?: ClientStatus;
  search?: string;
}

export function useClients(filters?: ClientFilters) {
  const [clients, setClients] = useState<Client[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadClients = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await clientService.getClients(filters);
      console.log('Loaded clients:', data); // Debug log
      setClients(data);
    } catch (err) {
      console.error('Error loading clients:', err); // Debug log
      setError(err instanceof Error ? err.message : 'Failed to load clients');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters?.status, filters?.search]);

  return {
    clients,
    loading,
    error,
    reload: loadClients,
  };
}

export function useClient(id: string) {
  const [client, setClient] = useState<Client | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadClient = async () => {
    try {
      setLoading(true);
      const data = await clientService.getClient(id);
      setClient(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load client');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      loadClient();
    }
  }, [id]);

  return {
    client,
    loading,
    error,
    reload: loadClient,
  };
}

